import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import './index.css';
import AppRoutes from './AppRoutes';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './hooks/useTheme'; // ⬅️ importa o ThemeProvider

const App = () => (
  <section className="absolute top-0 w-full h-full section-wrapper bg-gray-50">
    <AppRoutes />
  </section>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Router>
        <ThemeProvider> {/* ⬅️ envolve tudo com ThemeProvider */}
          <App />
        </ThemeProvider>
      </Router>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
